/**
 * @file 引入 public 目录的 CSS的配置页
 * @author zhangfengzhi
 * @date 2026-01-01
 * @description 接收参数cssFiles， CSS 文件路径数组
 */
'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';

// 定义全局 CSS 文件（这些不会被清理）
const GLOBAL_CSS: string[] = [
    // '/assets/css/globals.css',
    // '/assets/css/components.css',
];

export function usePublicCSS(cssFiles: string[]) {
    const pathname = usePathname();
    const prevPathname = useRef(pathname);

    useEffect(() => {
        // 判断是否是页面跳转（而不是刷新）
        const isNavigation = prevPathname.current !== pathname;
        prevPathname.current = pathname;

        // 如果是页面跳转，才清理
        if (isNavigation) {
            cleanupPreviousPageCSS();
        }

        // 添加当前页面的 CSS（如果尚未加载）
        cssFiles.forEach(href => {
            addCSS(href);
        });

        return () => {
            // 只有页面跳转时才清理
            if (isNavigation) {
                cssFiles.forEach(href => {
                    if (!GLOBAL_CSS.includes(href)) {
                        const link = document.querySelector(
                            `link[href="${href}"]`,
                        );
                        if (link) {
                            link.remove();
                        }
                    }
                });
            }
        };
    }, [cssFiles, pathname]);
}

function cleanupPreviousPageCSS() {
    document.querySelectorAll('link[data-page-css]').forEach(link => {
        const href = link.getAttribute('href');
        if (href && !GLOBAL_CSS.includes(href)) {
            link.remove();
        }
    });
}

function addCSS(href: string) {
    const existing = document.querySelector(`link[href="${href}"]`);
    if (!existing) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;

        // 标记页面级 CSS（非全局的）
        if (!GLOBAL_CSS.includes(href)) {
            link.setAttribute('data-page-css', 'true');
        }

        document.head.appendChild(link);
    }
}
